import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import HeatmapSourceImage from "types/Heatmap/HeatmapSourceImage";
import { getProjectHeatmapSettings } from "slices/projectHeatmapSettings/projectHeatmapSettingsSlice";
import { LoadingState } from "types";

export interface SelectedImageState {
  selectedImage: HeatmapSourceImage | null;
  selectedImageWidth: number;
  selectedImageHeight: number;
  selectedImageSize: number | null;
  coefficient: number;
  isExpanded: boolean;
  loading: LoadingState;
}

const initialState: SelectedImageState = {
  selectedImage: null,
  selectedImageWidth: 0,
  selectedImageHeight: 0,
  selectedImageSize: null,
  coefficient: 1,
  isExpanded: false,
  loading: LoadingState.idle,
};

const selectedImageSlice = createSlice({
  name: "selectedImage",
  initialState: initialState,
  reducers: {
    resetSelectedImage: () => initialState,
    setSelectedImage: (state, action: PayloadAction<HeatmapSourceImage>) => {
      state.selectedImage = action.payload;
      state.loading = LoadingState.pending;
    },
    setSelectedImageWidth: (state, action: PayloadAction<number>) => {
      state.selectedImageWidth = action.payload;
    },
    setSelectedImageHeight: (state, action: PayloadAction<number>) => {
      state.selectedImageHeight = action.payload;
    },
    setSelectedImageSize: (state, action: PayloadAction<number>) => {
      state.selectedImageSize = action.payload;
    },
    setSelectedImageExpanded: (state, action: PayloadAction<boolean>) => {
      state.isExpanded = action.payload;
    },
    setSelectedCoefficient: (state, action: PayloadAction<number>) => {
      if (action.payload <= 0) {
        state.coefficient = 1;
      } else {
        state.coefficient = action.payload;
      }
    },
    setSelectedImageLoading: (state, action: PayloadAction<LoadingState>) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProjectHeatmapSettings.fulfilled, (state, action) => {
      const selectedImage = action.payload.projectSettings.selectedImage;
      return selectedImage ?? initialState;
    });
  },
});

export const {
  setSelectedImage,
  setSelectedImageWidth,
  setSelectedImageHeight,
  setSelectedImageSize,
  setSelectedCoefficient,
  setSelectedImageLoading,
  resetSelectedImage,
  setSelectedImageExpanded,
} = selectedImageSlice.actions;

export default selectedImageSlice.reducer;
